import {
  Button,
  Checkbox,
  Field,
  Input,
  Select,
  SliderModal
} from '@see-ui/core';
import React from 'react';
import * as service from '@services/api/member-pharmacy-service';
import { useGlobalStore } from '@services/store/global-store';

const EditCardsSlider: React.FC<{
  onClose: () => void;
  card: any;
  onUpdatePaymentMethods: any;
}> = ({ onClose, card, onUpdatePaymentMethods }) => {
  const [isDefault, setIsDefault] = React.useState(card.isDefaultPaymentMethod);
  const [expMonth, setExpMonth] = React.useState(card.card.expirationMonth);
  const [expYear, setExpYear] = React.useState(card.card.expirationYear);
  const { memberDetails } = useGlobalStore((state) => state);

  const handleCheckboxChange = (checked: boolean) => {
    setIsDefault(checked);
  };

  const handleUpdate = async () => {
    const addReq = {
      action: 'UPD',
      paymentMethod: {
        ...card,
        isDefaultPaymentMethod: isDefault,
        card: {
          ...card.card,
          expirationMonth: expMonth,
          expirationYear: expYear
        }
      }
    };
    const response = await service.addUpdatePaymentMethod({
      hcid: memberDetails?.member?.memberPolicy?.hcid,
      updateRequest: addReq
    });
    if (response?.data) {
      //load the data
      const getPaymentMethodResp = await service.getPaymentMethod({
        hcid: memberDetails?.member?.memberPolicy?.hcid
      });
      if (getPaymentMethodResp?.data) {
        onUpdatePaymentMethods(getPaymentMethodResp.data?.paymentMethods);
      }
    } else {
      console.log('Failed to delete payment method');
    }
    onClose();
  };
  return (
    <>
      <SliderModal
        direction="right"
        labelAriaCloseBtn="Close Modal"
        onClose={onClose}
        open
      >
        <SliderModal.Body>
          <h2 className="pb-5">Edit Credit or Debit Card</h2>
          <div>
            <Field
              label={
                <span className="font-semibold">
                  Cardholder’s Name (enter name as it appears on the card)
                </span>
              }
              name="name"
            >
              <Input value={card.card.cardHolderName} type="text" disabled />
            </Field>
          </div>

          <div className="mt-4">
            <Field
              label={
                <span className="font-semibold">
                  Address on Account (Cardholder's billing address)
                </span>
              }
              name="name"
            >
              <Input value={card.address.addressLine1} type="text" disabled />
            </Field>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-2 gap-4 mt-4">
            <div>
              <Field
                label={<span className="font-semibold">City</span>}
                name="name"
              >
                <Input value={card.address.city} type="text" disabled />
              </Field>
            </div>
            <div>
              <Field
                label={<span className="font-semibold">Zip Code</span>}
                name="name"
              >
                <Input value={card.address.zipCode} type="text" disabled />
              </Field>
            </div>
          </div>

          <div className="mt-4">
            <Field
              label={<span className="font-semibold">Card</span>}
              name="name"
            >
              <Input value={card.card.cardNumber} type="text" disabled />
            </Field>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-2 gap-4 mt-4">
            <div>
              <Field
                name="expMonth"
                required
                label={<span className="font-semibold">Month</span>}
              >
                <Select
                  name="expMonth"
                  value={expMonth}
                  onValueChange={setExpMonth}
                  options={Array.from({ length: 12 }, (_, i) => ({
                    label: (i + 1).toString().padStart(2, '0'),
                    value: (i + 1).toString().padStart(2, '0')
                  }))}
                  required
                />
              </Field>
            </div>
            <div>
              <Field
                name="expYear"
                required
                label={<span className="font-semibold">Year</span>}
              >
                <Select
                  name="expYear"
                  value={expYear}
                  onValueChange={setExpYear}
                  options={Array.from({ length: 21 }, (_, i) => {
                    const year = 2026 + i;
                    return { label: year.toString(), value: year.toString() };
                  })}
                  required
                />
              </Field>
            </div>
          </div>
          <Checkbox
            className="mt-6"
            name="isDefault"
            label="Make this the primary payment method for all your pharmacy orders"
            checked={isDefault}
            onCheckedChange={handleCheckboxChange}
            disabled={card.isDefaultPaymentMethod}
          />
          <p className="mt-4">
            Any updates you make to your card information today will be used for
            all future payments.
          </p>
        </SliderModal.Body>
        <SliderModal.Footer>
          <Button onClick={onClose} className="mr-4" variant="secondary">
            Cancel
          </Button>
          <Button onClick={handleUpdate}>Update</Button>
        </SliderModal.Footer>
      </SliderModal>
    </>
  );
};

export default EditCardsSlider;
